import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import RootReducer from "./root-reducer";

const persistConfig = {
    key: process.env.REACT_APP_STORAGE_KEY,
    storage
}
const persistedReducer = persistReducer(persistConfig, RootReducer)

export const store = createStore(persistedReducer);
export const persistStoreObject = persistStore(store)
